Vue.component("ticket-settings", {

    props: ["settings"],

    data () {
        return {
            form: new AppForm({
                reminder_in_days_low: this.settings.reminder_in_days_low,
                reminder_in_days_medium: this.settings.reminder_in_days_medium,
                reminder_in_days_high: this.settings.reminder_in_days_high,

                task_card_include_landlord_details: this.settings.task_card_include_landlord_details,
                task_card_include_tenant_details: this.settings.task_card_include_tenant_details,
                task_card_requires_quality_assurance_sign_off: this.settings.task_card_requires_quality_assurance_sign_off,
                task_card_generate_pdf: this.settings.task_card_generate_pdf,
                task_card_include_issue_photos: this.settings.task_card_include_issue_photos,
                task_card_include_signature_lines: this.settings.task_card_include_signature_lines,
            }),
        };
    },

    mounted () {
        this.autoSelectMaintenanceRequestsTab("#tab-maintenance-requests");
    },

    methods: {
        autoSelectMaintenanceRequestsTab (reference) {
            let url = new URL(window.location.href);
            if (url.hash == reference) {
                let activeTabs = document.querySelectorAll("a[role='tab']");
                let activePanels = document.querySelectorAll("div[role='tabpanel']");

                activeTabs.forEach(function (tab) {
                    tab.classList.remove("active");
                    if (tab.getAttribute("href") === reference) {
                        tab.classList.add("active");
                    }
                });
                activePanels.forEach(function (tab) {
                    tab.className = "tab-pane fade";
                    // because tab.id returns the id without the # we need to use substring
                    if (tab.id == reference.substr(1, reference.length)) {
                        tab.classList.add("active");
                        tab.classList.add("show");
                    }
                });
            }
        },
        updateSettings () {
            App.patch("/settings/tickets/" + this.settings.id + "/update", this.form)
            .then(() => {
                toastr.success("Ticket settings successfully updated");
            }).catch((error) => {
                toastr.error("Could not update ticket settings. Error: " + error);
            });
        }
    }
});
